import { countryWithCodeSlice } from "./countryWithCodeSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = countryWithCodeSlice;
const moduleUrl = '/api/pricing/pricingProcedures/country'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);